function getDocumentBodyStrict(): HTMLElement {
    if (document.body === null) {
        throw new Error("Scrolling can be used only in browser");
    }

    return document.body;
}

export function findScrollableParent(el: HTMLElement): HTMLElement {
    let isBody = false;
    let hasScrollableSpace = false;
    let hasVisibleOverflow = false;
    let currentElement: HTMLElement = el;

    do {
        if (currentElement.parentElement === null || !(currentElement.parentElement instanceof HTMLElement)) {
            return getDocumentBodyStrict();
        }
        currentElement = currentElement.parentElement;
        isBody = currentElement === document.body;
        hasScrollableSpace =
            currentElement.clientHeight < currentElement.scrollHeight ||
            currentElement.clientWidth < currentElement.scrollWidth;
        hasVisibleOverflow = window.getComputedStyle(currentElement).overflow === "visible";
    } while (!isBody && !(hasScrollableSpace && !hasVisibleOverflow));

    return currentElement;
}
